@if (count > 0) {
  <div class="bulk-action-bar fadeIn" role="toolbar">
    <span class="bulk-action-bar__count" aria-live="polite">{{ 'BULK_ACTIONS.SELECTED' | translate : { count: count } }}</span>
    @if (canSelectAll && !allMatching) {
      <button class="btn btn-sm btn-link bulk-action-bar__select-all" type="button" (click)="selectAll.emit()">{{ 'BULK_ACTIONS.SELECT_ALL' | translate : { total: total } }}</button>
    }
    <span class="bulk-action-bar__divider"></span>
    <div class="bulk-action-bar__actions">
      @for (a of visibleActions; track a) {
        <button class="btn btn-sm v-btn" type="button" [ngClass]="a.style" (click)="a.handler()">@if (a.icon) {
          <i class="lnr me-2" aria-hidden="true" [ngClass]="a.icon"></i>
        }{{ a.labelKey | translate }}</button>
      }
    </div>
    <span class="bulk-action-bar__divider"></span>
    <button class="btn bulk-action-bar__close" type="button" (click)="clear.emit()" [attr.aria-label]="'BULK_ACTIONS.CLEAR' | translate" [tooltip]="'BULK_ACTIONS.CLEAR' | translate" container="body"><i class="lnr lnr-cross" aria-hidden="true"></i></button>
  </div>
}
